import React from 'react';
import { BaseIcon } from '../base/BaseIcon';
import { IconProps } from '../types';

export const FallLinearIcon = React.memo<IconProps>(
  ({
    className = '',
    size = 24,
    color = 'currentColor',
    onClick,
    strokeWidth,
  }) => (
    <BaseIcon
      className={className}
      size={size}
      color={color}
      onClick={onClick}
      viewBox="0 0 24 24"
    >
      <path
        d="M23.8201 19.43L12.8201 3.43002C12.4501 2.89002 11.5401 2.89002 11.1701 3.43002L0.180059 19.43C-0.129941 19.89 -0.0199406 20.51 0.440059 20.82C0.890059 21.13 1.52006 21.02 1.83006 20.56L12.0001 5.77002L22.1801 20.57C22.4901 21.03 23.1201 21.14 23.5701 20.83C24.0301 20.52 24.1401 19.89 23.8301 19.44L23.8201 19.43Z"
        fill={color}
      />
    </BaseIcon>
  ),
);

FallLinearIcon.displayName = 'FallLinearIcon';
